<template>
  <div class="auth-container">
    <div class="auth-center-wrapper" v-loading="loading">
      <div class="form">
        <img class="form-logo" src="../assets/images/logo.svg" alt="P" />
        <div class="congrate-text">
          <p>Xush kelibsiz,</p>
          <h3>Tizimga kirish</h3>
        </div>
        <div class="login-form">
          <LoginForm />
        </div>
      </div>
      <div class="info">
        <img class="logo" src="../assets/images/logo.svg" alt="P" />
        <!--        <p class="desc">"Ochiq budjet" axborot timzimi</p>-->
        <div class="footer">
          O’zbekiston Respublikasi Iqtisodiyot va Moliya Vazirligi huzuridagi “Axborot
          <br />
          Texnologiyalari Markazi”
          <p>© {{new Date().getFullYear()}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from "@/components/auth/LoginForm";

export default {
  name: "AuthPage",
  components: { LoginForm },
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style scoped>
.auth-container {
  height: 100vh;
  overflow: auto;
  background-color: #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-center-wrapper {
  max-width: 820px;
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}

.auth-center-wrapper > .form,
.auth-center-wrapper > .info {
  flex-basis: 50%;
}

.auth-center-wrapper > .form {
  padding: 30px 25px;
}

.auth-center-wrapper > .form .login-form {
  margin-top: 30px;
}

.form .form-logo {
  margin-bottom: 10px;
}

.form .congrate-text {
  margin-top: 20px;
}

.form .congrate-text > p {
  margin-bottom: 5px;
}

.form .congrate-text > h3 {
  font-size: 20px;
  font-family: "Montserrat-Bold", sans-serif;
}

.auth-center-wrapper > .info {
  background-image: url("@/assets/images/auth-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  padding: 30px 25px;
  position: relative;
}

.auth-center-wrapper > .info > .logo {
  margin-top: 20px;
}

.auth-center-wrapper > .info > .desc {
  color: #fff;
  font-size: 14px;
  line-height: 24px;
  margin-top: 20px;
}

.auth-center-wrapper > .info > .footer {
  position: absolute;
  bottom: 15px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  width: calc(100% - 50px);
  text-align: center;
}

.auth-center-wrapper > .info > .footer > p {
  margin-top: 5px;
}

.form-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #007791;
  width: 100%;
  height: 50px;
  border-radius: 4px;
  margin-top: 15px;
  color: #ffffff;
  text-decoration: none;
  font-family: "Montserrat-Medium", sans-serif;
}

.form-button:hover {
  opacity: 0.8;
}

@media screen and (max-width: 800px) {
  .auth-container {
    height: 100%;
  }

  .auth-center-wrapper {
    flex-direction: column;
  }

  .info {
    min-height: 400px;
    order: 0;
  }

  .form {
    order: 1;
  }

  .form-logo {
    display: none;
  }
}
</style>
